module.exports = __webpack_public_path__ + "e3984b583de9d7f9db4c86cbf43020cb.png";